import { EmptyState } from '@/lib/base/empty-state/empty-state';
import { cx } from '@/utils/cx';

interface ProposalNoAccessStateProps {
  onBack?: () => void;
  className?: string;
}

export function ProposalNoAccessState({
  onBack,
  className,
}: ProposalNoAccessStateProps) {
  const action = onBack
    ? { label: 'Back to actions', onClick: onBack }
    : undefined;

  return (
    <div
      className={cx(
        'flex h-full w-full items-center justify-center',
        className
      )}
    >
      <EmptyState
        variant='empty'
        title="You don't have access to this action"
        description="This action isn't shared with you."
        action={action}
      />
    </div>
  );
}
